import style from './ITSupport.module.css';

export default function ITSupport() {
    return (
        <div className={style.support}>
            <div className="intranet_tile_header">IT-hjelp</div>
            <div className={style.body}>
                <div className={style.brandRow}>
                    <span className={style.brand}>IT.no</span>
                    <span className={style.brandDot}>·</span>
                    <span className={style.role}>Support</span>
                </div>
                <a className={style.phone} href="tel:+4722535333" aria-label="Ring IT-support">
                    22 53 53 33
                </a>
                <a className={style.email} href="mailto:support@it.no">
                    support@it.no
                </a>
                <div className={style.hours}>Man–fre&nbsp;·&nbsp;08–18</div>
                <div className={style.emergency}>
                    <span className={style.emergencyKicker}>Vakttelefon</span>
                    <span className={style.emergencyText}>Døgnåpen for kritiske henvendelser.</span>
                </div>
            </div>
        </div>
    );
}
